var map = {
	"./About Section Image.jpeg": 892,
	"./Screenshot Webpage.png": 860,
	"./avatar-1.jpg": 749,
	"./avatar-2.jpg": 498,
	"./avatar-3.jpg": 335,
	"./cursor.png": 346,
	"./project-fitness.webp": 206,
	"./project-habittracker.webp": 328,
	"./project-img-2.jpg": 934,
	"./project-stashly.webp": 436,
	"./project-tools.webp": 741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;